module.exports = __webpack_public_path__ + "static/img/super-chat-pass-off.0507a7c8.png";